let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2VAr2")).then(() => parcelRequire('62Ykk'));